// The BE's own message for a failed call: `errors[].message`, else `message`,
// else axios's message (e.g. a network failure).
export const getApiErrorMessage = (error) => {
  const body = error?.response?.data;
  const errorMessages = (body?.errors || []).map(({ message }) => message).filter(Boolean);
  if (errorMessages.length) return errorMessages.join('. ');
  return body?.message || error?.message || '';
};
